import FFObserver from 'fontfaceobserver'

export default (onLoad) => {
  const effectiveFont = new FFObserver('effective-font')
  const fontAwesome = new FFObserver('Font Awesome 5 Pro')

  Promise.all([effectiveFont.load(), fontAwesome.load()]).then(onLoad, onLoad)
}
